<div class="container-record-items" id="container-record-items">
  <div class="reference-anchor" id="container-record-items-anchor"></div>
  <app-record-slider
    [items]="swiperItems"
    [showActions]="true"
    [useCardDisplay]="true"
    (indexClicked)="onItemClicked($event)">
    <ng-template appSliderTitle>
      <div class="header__left">
        <h2 class="header__left__title" (click)="goToViewMore()">
          {{ parentFocused ? lastEpisodesText : record.title }}
        </h2>
        <span class="header__left__total-items hide-mobile">{{ record.containerData.totalItems }}</span>
      </div>
    </ng-template>

    <ng-template appSliderActions>
      <div class="header__right">
        <button
          mat-flat-button
          class="accent transparent hide-mobile"
          *ngIf="record.containerData.totalItems > record.containerData.lastRssItems.length"
          (click)="goToViewMore()">
          {{ 'general.viewMore' | translate }}
        </button>
        <span class="odilo-icon next hide-tablet" aria-hidden="true" (click)="goToViewMore()">navigate_next</span>
      </div>
    </ng-template>
  </app-record-slider>
</div>
